<ng-container [ngTemplateOutlet]="cardTemplateData ? dataView.doesNotExist ? DoesNotExist : CardContent : NoData"></ng-container>

<ng-template #CardContent>

  <!-- DRILL AROUND ICON -->
  @if (listSpec.drillAroundMode && !isFilterList) {
    <div class="lm-list-card-drill-button-wrapper">
      <div class="lm-list-card-drill-button-container">
        <button soho-button="icon"
          id="drill_button"
          data-automation-id="lm-drill-around-button"
          soho-tooltip content="{{ 'Drill' | translate }}"
          attr.row-index="{{this.rowIndex}}"
          [icon]="'drill'"
          (click)="onDrillClicked($event)"
          >
        </button>
      </div>
    </div>
  }

  <div class="lm-card-view-wrapper">
    <!-- CARD CONTENT   -->
    <div class="lm-card-view" [attr.data-automation-id]="automationId">
      <!-- Card has image -->
      @if (cardTemplateData?.image?.imageUrl) {
        <div class="{{cardTemplateData?.image?.cardImageClasses}}" attr.data-automation-id="{{cardTemplateData?.automationId}}-image-container">
          <!-- Standard image without "link is and not largeImageIs" -->
          @if (
            !cardTemplateData?.image?.displayAsNavigation &&
            !cardTemplateData?.image?.displayAsLink &&
            !cardTemplateData?.image?.largeImage) {
            <img class="avatar large" [class.lm-context-card-image]="isContextCardView" [src]="cardTemplateData?.image?.imageUrl" alt="" draggable="false" >
          }
          <!-- Image with "link is" with navigation params -->
          @if (cardTemplateData?.image?.displayAsNavigation) {
            <a href="javascript:void(0)"
              (click)="navigate($event, null, cardTemplateData?.image?.navigationParams)"
              (keydown)="navigate($event, null, cardTemplateData?.image?.navigationParams)"
              attr.data-automation-id="{{cardTemplateData?.automationId}}-image"
              soho-tooltip [content]="cardTemplateData?.image?.navigationParams?.openInOverlay ? flyoutTooltip : null">
              <img class="avatar large" [class.lm-context-card-image]="isContextCardView" [src]="cardTemplateData?.image?.imageUrl" alt="" draggable="false" >
            </a>
          }
          <!-- Image with "link is" with httpUrl (can navigate internally or externally) -->
          @if (cardTemplateData?.image?.displayAsLink) {
            <a
              (click)="openLink($event, cardTemplateData?.image?.href, cardTemplateData?.image?.openExternal)"
              (keydown)="openLink($event, cardTemplateData?.image?.href, cardTemplateData?.image?.openExternal)"
              attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
              <img class="avatar large" [class.lm-context-card-image]="isContextCardView" [src]="cardTemplateData?.image?.imageUrl" alt="" draggable="false" >
            </a>
          }
          @if (cardTemplateData?.image?.largeImage) {
            <a
              (click)="openLargeImage($event, cardTemplateData?.image?.largeImage)"
              (keydown)="openLargeImage($event, cardTemplateData?.image?.largeImage)"
              attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
              <img class="avatar large" [class.lm-context-card-image]="isContextCardView" [src]="cardTemplateData?.image?.imageUrl" alt="" draggable="false" >
            </a>
          }
        </div>
      }

      <!-- Card does not have image and is using random avatars for missing image -->
      @if (!cardTemplateData?.image?.imageUrl && cardTemplateData?.image?.isMissingImage && cardTemplateData?.image?.isRandomBackground) {
        <div class="{{cardTemplateData?.image?.cardImageClasses}}">
          @if (cardTemplateData?.image?.displayAsNavigation || cardTemplateData?.image?.displayAsLink) {
            @if (cardTemplateData?.image?.displayAsNavigation) {
              <a href="javascript:void(0)"
                (click)="navigate($event, null, cardTemplateData?.image?.navigationParams)"
                (keydown)="navigate($event, null, cardTemplateData?.image?.navigationParams)"
                attr.data-automation-id="{{cardTemplateData?.automationId}}-image"
                soho-tooltip [content]="cardTemplateData?.image?.navigationParams?.openInOverlay ? flyoutTooltip : null">
                <span class="{{cardTemplateData?.image?.bgColorClass}}" [class.lm-context-card-image]="isContextCardView">{{cardTemplateData?.image?.imageForegroundText}}</span>
              </a>
            }
            @if (cardTemplateData?.image?.displayAsLink) {
              <a
                (click)="openLink($event, cardTemplateData?.image?.href, cardTemplateData?.image?.openExternal)"
                (keydown)="openLink($event, cardTemplateData?.image?.href, cardTemplateData?.image?.openExternal)"
                attr.data-automation-id="{{cardTemplateData?.automationId}}-image">
                <span class="{{cardTemplateData?.image?.bgColorClass}}" [class.lm-context-card-image]="isContextCardView">{{cardTemplateData?.image?.imageForegroundText}}</span>
              </a>
            }
          } @else {
            <span class="{{cardTemplateData?.image?.bgColorClass}}" [class.lm-context-card-image]="isContextCardView">{{cardTemplateData?.image?.imageForegroundText}}</span>
          }
        </div>
      }

      <div class="lm-card-content">
        <div #FlexContainer class="lm-card-flex">
          @for (cols of cardTemplateData.columns; track cols; let x = $index) {
            <ng-container>
              <div #CardColumn [ngStyle]="{ 'width.%': cols.percent ? cols.percent : null, 'flex-grow': cols.percent ? 0 : null }" class="lm-column lm-align-{{cols.align}}">
                @for (item of cols.column; track item; let i = $index) {
                  <div class="lm-card-row" [ngClass]="{'lm-hyperlink-container': (item.isExternalNavigation || item.isInternalNavigation) && !(boldFirstRow && i === 0)}">
                    @if (item.label) {
                      <label lm-text-style [textStyle]="item?.textStyle" class="lm-card-label">{{item.label}}:</label>
                    }
                    @if (!item.alertCondition) {
                      @if (!item.displayAsTag && !item.displayAsRating) {
                        @if (item.isExternalNavigation) {
                          <a href="{{item?.httpUrl}}" class="lm-card-field hyperlink" [target]="item.openExternal ? '_blank' : ''" lm-field-style [fieldStyle]="item?.fieldStyle" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                        }
                        @if (item.isInternalNavigation) {
                          <a href="javascript:void(0)"
                             class="lm-card-field hyperlink"
                             (click)="navigate($event, item)"
                             (keydown)="navigate($event, item)"
                             lm-field-style
                             [fieldStyle]="item?.fieldStyle"
                             soho-tooltip [title]="item?.openInOverlay ? flyoutTooltip : item?.displayValue">{{item?.displayValue}}</a>
                        }
                      }
                      <!-- display as tag -->
                      @if (item.displayAsTag) {
                        <div class="lm-card-tag-container">
                          @if (item.isField) {
                            <span
                              class="tag"
                              [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                              lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                            >{{item?.displayValue}}</span>
                          }
                          @if (item.isExternalNavigation) {
                            <a
                              href="{{item?.httpUrl}}"
                              [target]="item.openExternal ? '_blank' : ''"
                              class="lm-card-field tag is-clickable"
                              [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                              lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                              >
                              <span>{{item?.displayValue}}</span>
                              <span>
                                <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                  <use xlink:href="#icon-caret-right"></use>
                                </svg>
                                <span class="audible"></span>
                              </span>
                            </a>
                          }
                          @if (item.isInternalNavigation) {
                            <a
                              href="javascript:void(0)"
                              (click)="navigate($event, item)"
                              (keydown)="navigate($event, item)"
                              class="lm-card-field tag is-clickable"
                              [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                              lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                              soho-tooltip [content]="item?.openInOverlay ? flyoutTooltip : null"
                              >
                              <span>{{item?.displayValue.trim()}}</span>
                              <span>
                                <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                  <use xlink:href="#icon-caret-right"></use>
                                </svg>
                                <span class="audible"></span>
                              </span>
                            </a>
                          }
                        </div>
                      }
                      <!-- display as rating -->
                      @if (item.displayAsRating) {
                        <div soho-rating class="lm-card-field is-readonly" [style.padding-top]="'3px'">
                          <fieldset>
                            <!--        <legend class="audible">Rate Your Experience</legend>-->
                            @for (option of item.ratingOptions; track option; let i = $index) {
                              <input
                                type="radio"
                                [ngClass]="option.class"
                                name="rating_options"
                                id="{{option.id}}"
                                [attr.disabled]="true">
                                <label for="{{option.id}}" class="lm-card-label">
                                  <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                    <use [attr.xlink:href]="option.href"></use>
                                  </svg>
                                  <span class="audible">{{option.label}}</span>
                                </label>
                              }
                            </fieldset>
                          </div>
                        }
                        <!-- is field  -->
                        @if (item.isField && !item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating) {
                          <span
                            class="lm-card-field"
                            lm-field-style [fieldStyle]="item?.fieldStyle"
                            soho-tooltip [content]="item.displayValue" [placement]="'bottom'" [delay]="1000"
                            [ngStyle]="{'-webkit-line-clamp' : item.lines }"
                          >{{item?.displayValue}}</span>
                        }
                        <!-- is form text-->
                        @if (item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating && !(item.isExternalNavigation || item.isInternalNavigation)) {
                          <span
                            [ngStyle]="{'-webkit-line-clamp' : item.lines }"
                            soho-tooltip [content]="item.displayValue" [placement]="'bottom'" [delay]="1000"
                            class="lm-card-field {{item?.displayAsAlert?.color}}"
                            lm-text-style [textStyle]="item?.textStyle"
                            >
                            @if (item.icon && item.icon.sohoIcon || item?.displayAsAlert?.icon) {
                              <svg soho-icon
                                class="icon {{item?.displayAsAlert?.color}}"
                                [icon]="item?.displayAsAlert?.icon ? item?.displayAsAlert?.icon : item.icon.icon"
                                [attr.title]="item.displayValue"
                                soho-tooltip [content]="item.displayValue" [placement]="'bottom'">
                              </svg>
                            }
                            @if (item.icon && !item.icon.sohoIcon && !item?.displayAsAlert) {
                              <img class="icon" src="{{item.icon.iconUrl}}" draggable="false" >
                              }{{item?.displayValue}}
                            </span>
                          }
                          <!-- is rich text-->
                          @if (item.isField && !item.displayAsTag && !item.isFormText && item.isRichText && !item.displayAsRating) {
                            <span
                              class="lm-card-field"
                              lm-text-style [textStyle]="item?.textStyle"
                              [innerHTML]="item.displayValue | safe"
                            ></span>
                          }
                          <!-- process indicator -->
                          @if (item.isProcessIndicator) {
                            <div class="process-indicator compact responsive has-labels">
                              <div class="display">
                                @for (data of item.processIndicatorDisplayData; track data; let i = $index) {
                                  <div class="step" id="step{{data.stepId}}">
                                    <div class="lines">
                                      <div class="indicator {{data.completionStatusInfo.indicatorClass}}" [ngClass]="{'icon': data.completionStatusInfo.iconInfo.icon}" soho-tooltip content="{{data | lmProcessIndicatorTooltip}}">
                                        @if (data.completionStatusInfo.iconInfo.icon) {
                                          <svg soho-icon icon="{{data.completionStatusInfo.iconInfo.icon}}" class="{{data.completionStatusInfo.iconInfo.colorClass}}"></svg>
                                        }
                                      </div>
                                      <span class="separator" [ngClass]="{'darker': (data.status === 'C' || data.status === 'X')}"></span>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <!-- form button -->
                          @if (item.isFormButton) {
                            <div>
                              @if (item?.cardButton?.isDisplayAsLink) {
                                <a class="lm-form-button hyperlink" lm-field-style [fieldStyle]="item?.fieldStyle"
                                  [attr.data-action-reference]="stringifyJson(item.cardButton?.actionReference)"
                                  (click)="onActionClicked($event)"
                                  (keydown)="onActionClicked($event)"
                                  >
                                  {{item.cardButton.actionReference?.label}}
                                </a>
                              }
                              @if (!item?.cardButton?.isDisplayAsLink) {
                                <button class="lm-form-button hyperlink" lm-field-style [fieldStyle]="item?.fieldStyle"
                                  [attr.data-action-reference]="stringifyJson(item.cardButton?.actionReference)"
                                  (click)="onActionClicked($event)"
                                  (keydown)="onActionClicked($event)"
                                  >
                                  @if (item.cardButton.icon) {
                                    <svg soho-icon [icon]="item.cardButton.icon" [extraIconClass]="'text-link'"></svg>
                                  }
                                  {{item.cardButton.actionReference?.label}}
                                </button>
                              }
                            </div>
                          }
                        }
                        <!-- with alert -->
                        @if (item.alertCondition) {
                          <label class="lm-card-field lm-card-alert " lm-field-style [fieldStyle]="item?.fieldStyle" [ngStyle]="{'-webkit-line-clamp' : item.lines, 'display': item.lines ? '-webkit-inline-box' : null}">

                            <!-- valid soho icon -->
                            @if (item?.alertCondition?.icon) {
                              <svg soho-icon [icon]="item.alertCondition.icon" [attr.aria-label]="[(item.alertCondition.alertTooltip || item.alertCondition.icon), item?.displayValue].join()" [attr.class]="alertClass(item)" [attr.title]="item.alertCondition.alertTooltip" soho-tooltip [content]="item.alertCondition.alertTooltip" [placement]="'bottom'"></svg>
                            }

                            <!-- non standard soho icon -->
                            @if (item?.alertCondition?.iconUrl) {
                              <img [src]="item.alertCondition.iconUrl" [attr.alt]="item.alertCondition.alertTooltip || item.alertCondition.icon" [attr.class]="alertClass(item)" [attr.title]="item.alertCondition.alertTooltip" soho-tooltip [content]="item.alertCondition.alertTooltip" [placement]="'bottom'" draggable="false" >
                            }

                            <!-- alert with "link is" -->
                            @if (item.isExternalNavigation) {
                                <a href="{{item?.httpUrl}}" class="lm-card-field hyperlink lm-hyperlink-with-alert" [target]="item.openExternal ? '_blank' : ''" lm-field-style [fieldStyle]="item?.fieldStyle" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                            } @else if (item.isInternalNavigation) {
                                <a href="javascript:void(0)"
                                  class="lm-card-field hyperlink lm-hyperlink-with-alert"
                                  (click)="navigate($event, item)"
                                  (keydown)="navigate($event, item)"
                                  lm-field-style
                                  [fieldStyle]="item?.fieldStyle"
                                  soho-tooltip [title]="item?.openInOverlay ? flyoutTooltip : item?.displayValue">{{item?.displayValue}}</a>
                            } @else {
                                <span>{{item?.displayValue}}</span>
                            }

                          </label>
                        }
                        <!-- display as progress bar -->
                        @if (item?.progressFieldData) {
                          <lm-simple-progress [lmProgressFieldData]="item.progressFieldData" class="lm-card-field lm-font-md"></lm-simple-progress>
                        }
                      </div>
                    }
                  </div>
                </ng-container>
              }
            </div>
          </div>

            @if (cardTemplateData?.buttonMenu?.length > 0) {
                <div class="lm-card-button-menu-container">
                    <button class="btn-actions lm-card-button-menu"
                        type="button"
                        attr.data-automation-id="{{cardTemplateData.automationId}}-button-menu-button"
                        soho-context-menu [lazyLoad]="true" [autoFocus]="true" [trigger]="'click'" menu="lm-{{listSpec?.busListSpec?.id}}-list-view-card-button-menu-{{rowIndex}}"
                        (click)="onButtonMenu($event)"
                    >
                        <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use href="#icon-more"></use>
                        </svg>
                        <span class="audible" data-translate="text">{{'MoreActions' | translate: cardTemplateData?.columns?.[0]?.column?.[0]?.displayValue}}</span>
                    </button>
                </div>
            }

            @if(cardTemplateData?.displayButtonMenuAsChevron) {
              <div class="lm-card-button-menu-container">
                <svg soho-icon [icon]="'caret-right'"></svg>
              </div>
            }
        </div>

        <!-- BUTTON ROW -->
        @if (cardTemplateData?.buttonRow?.length > 0) {
          <div class="lm-card-button-row lm-align-{{cardTemplateData.buttonRowAlignment}}">
            @for (b of cardTemplateData.buttonRow; track b) {
              <!-- icon only -->
              @if (b.isIconOnly) {
                @if (b.isIconOnly) {
                  <button
                    attr.data-automation-id="{{b?.automationId}}"
                    soho-button="icon" [isToggle]="b?.isToggle" [isTogglePressed]="b.state?.isPressed" [icon]="b.icon"
                    soho-tooltip [title]="b.actionReference?.cardViewFormButtonSpec?.openInOverlay ? flyoutTooltip : (b.displayTooltip ? b.actionReference?.label || b.actionReference?.tooltip : null)"
                    class="btn lm-icon-button"
                    lm-field-style [fieldStyle]="b?.fieldStyle"
                    [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                    [ngClass]="{'lm-missing-soho-icon': !b.icon}"
                    (click)="onActionClicked($event)"
                    (keydown)="onActionClicked($event)"
                    >
                    @if (b.icon) {
                      <span>{{b.actionReference?.label}}</span>
                    }
                    <ng-container>
                      <!-- Need nbsp, if span is empty then ids-enterprise css will hide it -->
                      @if (!b.icon) {
                        <span [ngStyle]="{'background-image': 'url(' + b.iconUrl + ')'}">&nbsp;</span>
                      }
                      <span class="audible">{{b.actionReference?.label}}</span>
                    </ng-container>
                  </button>
                }
              } @else {
                <!-- httpUrl (external link)-->
                @if (b.isOpenExternal) {
                  <a
                    [ngClass]="{'btn hyperlink': b.isDisplayAsLink, 'btn': !b.isDisplayAsLink}"
                    attr.data-automation-id="{{b?.automationId}}"
                    [attr.href]="b.httpUrl"
                    target="_blank"
                    (click)="external(b, $event)"
                    (keydown)="external(b, $event)"
                    >
                    <span>{{b.actionReference?.label}}</span>
                  </a>
                }
                <!-- display buttons as links -->
                @if (b.isDisplayAsLink && !b.isOpenExternal) {
                  <button
                    class="btn hyperlink"
                    attr.data-automation-id="{{b?.automationId}}"
                    lm-field-style [fieldStyle]="b?.fieldStyle"
                    [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                    soho-tooltip [content]="b.actionReference?.cardViewFormButtonSpec?.openInOverlay ? flyoutTooltip : null"
                    (click)="onActionClicked($event)"
                    (keydown)="onActionClicked($event)"
                    >
                    <span>{{b.actionReference?.label}}</span>
                  </button>
                }
                <!-- action buttons -->
                @if (!b.isDisplayAsLink && !b.isOpenExternal) {
                  <button
                    class="btn"
                    [ngClass]="{'lm-is-primary': b?.isPrimary}"
                    attr.data-automation-id="{{b?.automationId}}"
                    lm-field-style [fieldStyle]="b?.fieldStyle"
                    [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                    soho-tooltip [content]="b.actionReference?.cardViewFormButtonSpec?.openInOverlay ? flyoutTooltip : null"
                    (click)="onActionClicked($event)"
                    (keydown)="onActionClicked($event)"
                    >
                    <span>{{b.actionReference?.label}}</span>
                  </button>
                }
              }
            }
          </div>
        }
      </div>

    </ng-template>

    <ng-template #DoesNotExist>
      <del>
        <ng-container [ngTemplateOutlet]= "CardContent"></ng-container>
      </del>
    </ng-template>

    <ng-template #NoData>
      <p>{{noDataAvailable}}</p>
    </ng-template>

